import React, { memo } from 'react';

import type {
  Time} from '../../../../components/Filters/FilterByDate/FilterByDate';
import {
  FilterByDate,
  oneDay,
  oneMinute
} from '../../../../components/Filters/FilterByDate/FilterByDate';

const getTimesList: () => Time[] = () => [
  {
    label: '15M',
  },
  {
    label: '1H',
  },
  {
    label: '24H',
  },
  {
    label: '7D',
  },
  {
    label: '1M',
  },
  {
    label: '3M',
  },
  {
    label: 'All',
    defaultChecked: true,
  },
];

const OverviewDateFilter: React.FC = memo(() => {
  return (
    <FilterByDate
        customFirst
        items={getTimesList()}
      />
  );
});

export { OverviewDateFilter };
